<template>
  <component :is="isSelected" @switchPanel="switchP($event)">
  </component>
</template>
<script>
  import DonorSearchMap from "@/pages/DonorSearch/DonorSearchMap.vue"
  import DonorSearchResults from "@/pages/DonorSearch/DonorSearchResults.vue"
  export default {
    components: {
      DonorSearchMap: DonorSearchMap,
      DonorSearchResults: DonorSearchResults
    },

    data() {
      return {
        isSelected: 'DonorSearchMap'
      }
    },
    methods:{
      switchP(e){
        console.log("asdasd",e)
        this.isSelected=e
      }
    }
  }
</script>
